"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInputIcon = exports.StyledInput = exports.StyledInputBorder = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
var InputStatus;
(function (InputStatus) {
    InputStatus[InputStatus["initial"] = 0] = "initial";
    InputStatus[InputStatus["hover"] = 1] = "hover";
})(InputStatus || (InputStatus = {}));
const focusBoxShadowStyling = `0 0 0 2px ${tokens_1.COLOURS.greyscale.white},
    0 0 0 4px ${tokens_1.COLOURS.primary.blue[100]}`;
const hoverBorderStyling = `2px solid ${tokens_1.COLOURS.greyscale.metal}`;
const errorBorderStyling = `2px solid ${tokens_1.COLOURS.primary.red[75]}`;
const typographyOverrides = {
    margin: 0,
    color: tokens_1.COLOURS.greyscale.night,
    // line-height in IE & Opera doesn't work as expected for input fields - so to maintain a consistent look across browsers, we use line-height: normal and set a fixed height
    lineHeight: "normal",
};
const getInputBorderColour = ({ hasErrors, isFocused, disabled }, inputStatus = InputStatus.initial) => {
    if (hasErrors && !disabled) {
        return {
            border: errorBorderStyling,
            boxShadow: isFocused ? focusBoxShadowStyling : "",
        };
    }
    if (isFocused && !disabled) {
        return {
            border: hoverBorderStyling,
            boxShadow: focusBoxShadowStyling,
        };
    }
    if ((inputStatus === InputStatus.hover || isFocused) && !disabled) {
        return {
            border: hoverBorderStyling,
        };
    }
    return {
        border: tokens_1.BORDERS.normal.stone,
    };
};
exports.StyledInputBorder = styled_components_1.default.div `
    position: relative;
    pointer-events: none;
    width: 100%;

    &::before {
        ${tokens_1.BORDER_ALTERNATIVE}
        z-index: 0;
        border-radius: ${tokens_1.BORDERS.radius};
        transition: all 0.2s ease;

        ${(props) => getInputBorderColour(props)}
    }

    &:hover {
        &::before {
            ${(props) => getInputBorderColour(props, InputStatus.hover)}
        }
    }
`;
exports.StyledInput = styled_components_1.default.input `
    ::placeholder {
        ${tokens_1.TYPOGRAPHY.body.base}
        color: ${tokens_1.COLOURS.greyscale.stone};
    }

    pointer-events: auto;
    display: block;
    width: 100%;

    /* Input base font styles: font-weight, font-family, color */
    ${() => tokens_1.TYPOGRAPHY.body.base}

    /* Input font-size + line-height small devices */
    ${() => tokens_1.TYPOGRAPHY.body.mobile}

    /* Override the margin & color styling given by TYPOGRAPHY */
    ${typographyOverrides}
    ${({ disabled }) => (disabled ? { color: tokens_1.COLOURS.greyscale.stone } : null)}

    /* line-height in IE & Opera doesn't work as expected for input fields - so to maintain a consistent look across browsers, we use line-height: normal and set a fixed height */
    height: ${({ dimension }) => {
    switch (dimension) {
        case "large":
            return tokens_1.SIZES[6];
        case "medium":
        default:
            return tokens_1.SIZES[5];
    }
}};

    padding: ${({ dimension }) => tokens_1.BUTTON_FORM_FIELDS_PADDING.text[dimension]};
    ${({ hasIcon }) => hasIcon && `padding-left: ${tokens_1.SIZES[5]};`}
    border-radius: ${tokens_1.BORDERS.radius};
    border: none;
    background-clip: padding-box;

    /* Reset the box shadow implemented in the GlobalStyles - it will be replaced by the StyledInputBorder styling */
    &:focus {
        box-shadow: none;
    }

    &:disabled {
        background-color: ${tokens_1.COLOURS.greyscale.cloud};
    }

    @media (min-width: ${tokens_1.BREAKPOINTS.md}) {
        ${() => tokens_1.TYPOGRAPHY.body.desktop}

        /* Keep overriding margin & color given by TYPOGRAPHY */
        ${typographyOverrides}
    }
`;
exports.StyledInputIcon = styled_components_1.default.span `
    position: absolute;
    top: 50%;
    left: ${tokens_1.SIZES[1]};
    transform: translateY(-50%);

    display: flex;
    align-items: center;

    svg {
        line-height: normal;
    }
`;
//# sourceMappingURL=Input.styles.js.map